module.exports = __webpack_public_path__ + "assets/img/80865a1b0b0591522dbeb74da7031f84.svg";